var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-header header top-header"},[_c('div',{staticClass:"container-fluid"},[_c('nav-header')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }